import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import { useInterval } from "library/core/utility/hooks/interval";
import Modal from "library/components/modal";
import TailwindBox from "library/components/_tailwind/box";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindButton from "library/components/_tailwind/button";
import TailwindTranslatedText from "library/components/_tailwind/translated-text";
import ModalStore from "library/core/stores/modal";

interface Props {
  modalStore?: ModalStore;
  isOpen: boolean;
}

const AccountSuspendedModal: React.FC<Props> = ({ isOpen }) => {
  const [remainingSeconds, setRemainingSeconds] = useState(5);
  const [timerComplete, setTimerComplete] = useState(false);

  const forceCloseWindow = () => {
    try {
      window.open("", "_self");
      window.close();

      if (window.location) {
        window.location.replace("about:blank");
      }
    } catch (e) {
      console.error("Failed to close window:", e);
    }
  };

  useInterval(() => {
    if (remainingSeconds > 0) {
      setRemainingSeconds(remainingSeconds - 1);
    } else if (remainingSeconds === 0 && !timerComplete) {
      setTimerComplete(true);
      forceCloseWindow();
    }
  }, 1000);

  const handleLeaveClick = () => {
    forceCloseWindow();
  };

  return (
    <Modal
      open={isOpen}
      shouldCloseOnOverlayClick={false}
      showNativeCloseButton={false}
      backdropVariant='blur'
    >
      <TailwindBox
        padding={["p-8"]}
        backgroundColor={"bg-primary-bg-color"}
        width={"w-full"}
        maxWidth={"max-w-md"}
        margin={["mx-auto"]}
      >
        <TailwindFlex flexDirection={"flex-col"} alignItems={"items-center"}>
          <TailwindTranslatedText
            textAlign={"text-center"}
            fontWeight={"font-bold"}
            fontSize={"text-xl"}
            margin={["mb-4"]}
            descriptor={{
              id: "account-suspended-modal.title",
              defaultMessage: "Account Suspended",
            }}
          />
          <TailwindTranslatedText
            textAlign={"text-center"}
            margin={["mb-6"]}
            descriptor={{
              id: "account-suspended-modal.message",
              defaultMessage: "Your account has been suspended.",
            }}
          />

          {timerComplete ? (
            <TailwindButton
              onClick={handleLeaveClick}
              backgroundColor={"bg-red-500"}
              className={["hover:bg-red-600", "flex", "items-center"]}
              margin={["mt-2"]}
              padding={["px-6", "py-2"]}
              textAlign={"text-center"}
              justifyContent={"justify-center"}
              width={"w-28"}
              alignItems={"items-center"}
              display={"flex"}
              rounded={true}
            >
              <TailwindTranslatedText
                descriptor={{
                  id: "account-suspended-modal.leave-button",
                  defaultMessage: "Leave",
                }}
              />
            </TailwindButton>
          ) : (
            <TailwindTranslatedText
              textAlign={"text-center"}
              fontWeight={"font-semibold"}
              descriptor={{
                id: "account-suspended-modal.countdown",
                defaultMessage: "Closing window in {seconds} seconds...",
              }}
              values={{
                seconds: remainingSeconds,
              }}
            />
          )}
        </TailwindFlex>
      </TailwindBox>
    </Modal>
  );
};

export default inject("modalStore")(observer(AccountSuspendedModal));
